export const EVENT_DEFINITION_MAP = {
    // Zones
    'Za': { status: 'OPEN', deviceType: 'zone' },
    'Zb': { status: 'ARMED', deviceType: 'zone' },
    'Zd': { status: 'WARNING', deviceType: 'zone' },
    'Zf': { status: 'TROUBLE', deviceType: 'zone' },
    'Zh': { status: 'MISSING', deviceType: 'zone' },
    'Zi': { status: 'TAMPER', deviceType: 'zone' },
    'Zk': { status: 'TESTING', deviceType: 'zone' },
    'Zp': { status: 'COUNTED', deviceType: 'zone' },
    'Zr': { status: 'NORMAL', deviceType: 'zone' },
    'Zt': { status: 'TROUBLE', deviceType: 'zone' },
    'Zw': { status: 'FAULT', deviceType: 'zone' },
    'Zx': { status: 'BYPASSED', deviceType: 'zone' },
    'Zy': { status: 'NORMAL', deviceType: 'zone' },
    

    // Area
    'Zq': { status: null, deviceType: 'area' },

    // Door
    'Zj': { status: null, deviceType: 'door' },

    // Output   
    'Zc': { status: null, deviceType: 'output' },
}

export const AREA_EVENT_TYPE_MAP = {
    'OP': 'DISARMED',
    'CL': 'ARMED',
    'LA': 'LATE',
}

export const DOOR_EVENT_TYPE_MAP = {
    'DA': 'ACESS',
    'DO': 'OPEN',
    'DC': 'LOCKED',
    'HO': 'HELD_OPEN',
    'FO': 'FORCED',
}

export const OUTPUT_EVENT_TYPE_MAP = {
    'ON': 'ON',
    'OF': 'OFF',
    'PL': 'PULSE',
    'TP': 'TEMPORAL',
    'MO': 'MOMENTARY',
}

export function mapEventToStatus(metadata) {
    const { event_definition, event_type, device_type } = metadata

    if (event_definition === 'Zc') {
        if (device_type === 'door') return DOOR_ZC_EVENT_TYPE_MAP[event_type] || null
        if (device_type === 'output') return OUTPUT_EVENT_TYPE_MAP[event_type] || null
        return null
    }

    const mapped = EVENT_DEFINITION_MAP[event_definition]
    if (!mapped) return null

    if (mapped.deviceType === 'area') return AREA_EVENT_TYPE_MAP[event_type] || null
    if (mapped.deviceType === 'door') return DOOR_ZJ_EVENT_TYPE_MAP[event_type] || null

    return mapped.status || null
}

export const DOOR_ZC_EVENT_TYPE_MAP = {
    'ON': 'UNLOCKED',
    'OF': 'LOCKED',
    'DO': 'OPEN',
    'DC': 'CLOSED',
    'HO': 'HELD_OPEN',
    'FO': 'FORCED_OPEN',
}

// Zj (door access events)
export const DOOR_ZJ_EVENT_TYPE_MAP = {
    'DA': 'ACCESS_GRANTED',
    'AA': 'ACCESS_DENIED',
    'IA': 'ACCESS_DENIED',
    'IT': 'ACCESS_DENIED',
    'AP': 'ACCESS_DENIED',
    'IC': 'ACCESS_DENIED',
    'IL': 'ACCESS_DENIED',
    'WP': 'ACCESS_DENIED',
    'IN': 'ACCESS_DENIED',
}